export default function (href) {
  if (!href) {
    return '';
  }
  if (href.lastIndexOf('#', 0) === 0) {
    return window.location.href + href; // str starts with '#' tack on window.location.href
  }
  if (href.lastIndexOf('/', 0) === 0) {
    return window.location.origin + href; // str starts with '/' tack on window.location.origin
  }
  return href;
};
